(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '[data-rd-hero-autoheight]';

    const updateHeight = (slider, requestedSlide) => {
      const scroller = slider.querySelector(':scope > slideshow-container > slideshow-slides');
      if (!scroller) return;

      const slide =
        requestedSlide ||
        scroller.querySelector('slideshow-slide[aria-hidden="false"]') ||
        scroller.querySelector('slideshow-slide');

      if (!slide) return;

      requestAnimationFrame(() => {
        const height = Math.ceil(slide.getBoundingClientRect().height);
        if (!height) return;

        const currentHeight = parseFloat(scroller.style.height || '0');
        if (Math.abs(currentHeight - height) > 1) {
          scroller.style.height = `${height}px`;
        }
      });
    };

    const initSlider = (slider) => {
      if (!(slider instanceof HTMLElement) || slider.dataset.rdHeroHeightReady === 'true') return;
      slider.dataset.rdHeroHeightReady = 'true';

      const scroller = slider.querySelector(':scope > slideshow-container > slideshow-slides');
      if (!scroller) return;

      const refresh = () => updateHeight(slider);

      slider.addEventListener('slideshow:select', (event) => {
        updateHeight(slider, event.detail?.slide);
      });

      slider.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', refresh, { once: true });
      });

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(refresh);
        resizeObserver.observe(slider);
        slider.rdHeroResizeObserver = resizeObserver;
      } else {
        window.addEventListener('resize', refresh, { passive: true });
      }

      updateHeight(slider);
    };

    const initWithin = (root = document) => {
      if (root instanceof HTMLElement && root.matches(selector)) initSlider(root);
      root.querySelectorAll?.(selector).forEach(initSlider);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initWithin(document), { once: true });
    } else {
      initWithin(document);
    }

    document.addEventListener('shopify:section:load', (event) => initWithin(event.target));

    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll?.(selector).forEach((slider) => {
        slider.rdHeroResizeObserver?.disconnect();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
